const formatPhoneNumber = (value: string) => {
	if (!value) return '';
	
	const digits = value.replace(/\D/g, '');
	const formattedNumber = digits.replace(/(\d{2})(?=\d)/g, '$1 ').trim();
	
	return formattedNumber;
};

export default formatPhoneNumber;